<div class="seating">
  @for (m of participiants | keyvalue ; track m) {
    @if (m.value.position === filter) {
      <ng-container class="guest">
        <div><img [src]="getBase(m.key).url" title="{{getBase(m.key).name}} Glory:{{m.value.glory}}" (error)="fallback($event)"/></div>
      </ng-container>
    }
  }
</div>
